import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3.js";
import { mockData } from "./mockData";

const API = {
  // ##########################
  // Merge Controller
  // ##########################
  fetchSideBySidePreviewData: ({ mergeID }) =>
    mockData.USE_MOCK_DATA
      ? callMockResponse(mockData.sideBySide)
      : new FnrFetch3(`/merge/${mergeID}/sideBySidePreview`),

  fetchMergeData: ({ mergeID }) =>
    mockData.USE_MOCK_DATA
      ? callMockResponse(mockData.preview)
      : new FnrFetch3(`/merge/${mergeID}/preview`),

  doNotMerge: ({ mergeID }) => new FnrFetch3(`/merge/${mergeID}/cancel`),

  submitMerge: ({ mergeID, submitData }) =>
    new FnrFetch3(`/merge/${mergeID}/execute`, submitData),

  undoAccountMerge: ({ mergeID }) => new FnrFetch3(`/merge/${mergeID}/undo`),

  // ##########################
  // Duplicate Controller
  // ##########################
  getDuplicates: () =>
    mockData.USE_MOCK_DATA
      ? callMockResponse(mockData.duplicates)
      : new FnrFetch3("/duplicate/getDuplicates"),

  getDuplicateSideBySideData: ({ duplicateID }) =>
    mockData.USE_MOCK_DATA
      ? callMockResponse(mockData.sideBySide)
      : new FnrFetch3(`/duplicate/${duplicateID}/sideBySidePreview`),

  updateDuplicateStatus: ({ duplicateID, status }) =>
    mockData.USE_MOCK_DATA
      ? callMockResponse(mockData.duplicateStatus)
      : new FnrFetch3(`/duplicate/${duplicateID}/updateStatus`, { status }),

  promoteMergeCandidate: ({ duplicateID }) =>
    mockData.USE_MOCK_DATA
      ? callMockResponse(mockData.promoteCandidate)
      : new FnrFetch3(`/duplicate/${duplicateID}/promoteCandidate`),

  undoPromoteCandidate: ({ duplicateID }) =>
    mockData.USE_MOCK_DATA
      ? callMockResponse(mockData.undoPromoteCandidate)
      : new FnrFetch3(`/duplicate/${duplicateID}/undoPromoteCandidate`),
};

export default API;
